<template>
  <section v-if="list?.length" class="rounded-[10px] h-full flex flex-col absolute w-full">
    <div class="font-bold text-[14px] text-font-80 flex-y-center gap-[6px]">
      <iconpark-icon name="book-title" size="16"></iconpark-icon>
      {{ isSeries ? $t('tong-xi-lie-jiao-cheng') : $t('qi-ta-jiao-cheng') }}
    </div>
    <div class="overflow-auto flex-1 flex flex-col gap-[4px] pr-[5px] mt-[16px] other-list">
      <OtherCard v-for="item in list" :key="item.id" :data="item" :active="item.id === activeId" />
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Template } from '~/api/interface';
import OtherCard from './other-card.vue';

const props = defineProps<{
  list: Template[];
  activeId?: number;
  isSeries?: boolean;
}>();

const { $t } = useNuxtApp();

onMounted(() => {
  nextTick(() => {
    document.querySelector('.other-list .active')?.scrollIntoView({});
  });
});
</script>
